import { GlButton, GlButtonGroup, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import glFeatureFlagMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import UserCalloutDismisser from '../../vue_shared/components/user_callout_dismisser.vue?vue3';
import { isInPast, newDate } from '~/lib/utils/datetime/date_calculation_utility';
import { viewModeOptions } from 'ee_else_ce/work_items/view_modes';
import { BOARD_VIEW_POPOVER_END_DATE, VIEW_MODE_BOARD, VIEW_MODE_TABLE } from '../constants';
import WorkItemBoardViewPopover from './work_item_board_view_popover.vue?vue3';
export default {
    name: 'WorkItemViewModeToggle',
    components: {
        GlButton,
        GlButtonGroup,
        UserCalloutDismisser,
        WorkItemBoardViewPopover
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glFeatureFlagMixin()
    ],
    props: {
        viewMode: {
            type: String,
            required: true
        },
        isBoardEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        showBoardPopover: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'toggle-view-mode'
    ],
    computed: {
        shouldShowBoardPopover () {
            return this.showBoardPopover && this.isBoardEnabled && !isInPast(newDate(BOARD_VIEW_POPOVER_END_DATE));
        },
        isBoardViewActive () {
            return this.viewMode === VIEW_MODE_BOARD;
        },
        availableViewModeOptions () {
            return viewModeOptions.filter((option)=>{
                if (option.value === VIEW_MODE_TABLE) {
                    return Boolean(this.glFeatures.planningViewTable);
                }
                if (option.value === VIEW_MODE_BOARD) {
                    return this.isBoardEnabled;
                }
                return true;
            });
        }
    },
    methods: {
        boardButtonTarget (type) {
            return ()=>this.$refs.toggle?.querySelector(`[data-testid="view-mode-${type}-${VIEW_MODE_BOARD}"]`);
        },
        onToggleViewMode (newViewMode, { dismiss, shouldShowCallout } = {}) {
            if (newViewMode === VIEW_MODE_BOARD && this.shouldShowBoardPopover && shouldShowCallout) {
                dismiss();
            }
            this.$emit('toggle-view-mode', newViewMode);
        },
        isPressed (value) {
            return value === this.viewMode ? 'true' : 'false';
        }
    }
};
